/* ============
 * Mutations for the organisations module
 * ============
 *
 * The organisations that are available on the
 * organisation module.
 */

import types from './mutation-types';

export default {
  [types.FETCH_ORGANISATIONS](state) {
    state.organisationLoading = true;
  },
  [types.FETCH_ORGANISATIONS_SUCCESS](state, resp) {
    state.organisationLoading = false;
    state.organisation = resp;
  },
  [types.FETCH_ORGANISATIONS_FAIL](state, error) {
    state.organisationLoading = false;
    state.error = error;
  }
};
